import * as api from '../api'
import { FETCH_ALL_MATCH, CREATE_MATCH, DELETE_MATCH, UPDATE_MATCH, UPDATE_INFOMATCH } from '../constants/actionTypes.js'
import { updateLiveDetails } from './live.js'
import { contrainteNotification, deleteContrainteNotification } from './notifications.js'

// Action creator
export const getMatchs = () => async (dispatch) => {

    try{
        const {data} = await api.fetchMatchs()

        dispatch({ type: FETCH_ALL_MATCH, payload: data})
    } catch(error){
        console.log(error.message)
    } 
}

export const createMatch = (match) => async (dispatch) => {
    try {
        const { data } = await api.createMatch(match)

        dispatch( { type : CREATE_MATCH, payload: data})
    } catch(error){
        console.log(error.message)
    }
}

export const updateInfoMatch = (id, match) => async (dispatch) => {
    try{

        const formData = new FormData()
        Object.keys(match).map(key => {
                let noNull = match[key] ?? ""
                formData.append(key, noNull)
        })

        const { data } = await api.updateInfoMatch(id, formData)

        dispatch({ type : UPDATE_INFOMATCH, payload: data})

    } catch(error){
        console.log(error.message)
    }
}

export const updateMatch = (id, match, type, skipUpdate = false) => async (dispatch) => {
    try {
        
        const { data } = await api.updateMatch(id, match)

        dispatch({ type : UPDATE_MATCH, payload: data})

    } catch(error){
        console.log(error.message)
    }
}

export const forfaitMatch = (id, forfaitTeam) => async (dispatch) => {
    try {
        
        const { data } = await api.forfaitMatch(id, forfaitTeam)

        dispatch({ type : UPDATE_MATCH, payload: data})

    } catch(error){
        console.log(error.message)
    }
}

export const deleteMatch = (id) => async (dispatch) => {
    try {
        await api.deleteMatch(id)

        dispatch(deleteContrainteNotification(id))

        dispatch({ type : DELETE_MATCH, payload: id})
    }catch(error){
        const {error : serverError} = error.response.data

        const {statusCode, type, typeObject, idObject} = serverError

        if(statusCode===409 && type==='constraint'){
            // Un autre object doit etre supprimé avant
            dispatch(contrainteNotification(idObject, typeObject))
        }
    }
}